import React from "react";
import { useNavigate } from "react-router-dom";
import type { Profile } from "../../services/kindlyApi";
import styles from "./MentionText.module.css";
import { profilePath } from "../../../profile/profilePath";

interface MentionTextProps {
  text: string;
  profiles: Profile[];
}

export const MentionText: React.FC<MentionTextProps> = ({ text, profiles }) => {
  const navigate = useNavigate();

  // Parse text and find @mentions
  const parts = text.split(/(@\w+)/g);

  const handleMentionClick = (profile: Profile) => {
    navigate(profilePath(profile.id));
  };

  return (
    <span>
      {parts.map((part, index) => {
        if (part.startsWith("@")) {
          const mentionText = part.slice(1); // Remove @

          // Try to find matching profile by first name
          const profile = profiles.find(
            (p) => p.first_name.toLowerCase() === mentionText.toLowerCase(),
          );

          if (profile) {
            return (
              <span
                key={index}
                className={styles.mention}
                data-tip={`${profile.first_name} ${profile.last_name}`}
                onClick={() => handleMentionClick(profile)}
              >
                @{profile.first_name}
              </span>
            );
          }
        }

        return <span key={index}>{part}</span>;
      })}
    </span>
  );
};
